import React, { useEffect, useMemo, useState } from "react";
import SectionField from "../section/SectionField";
import styles from "./PhotoComponent.module.scss";
import InputTextArea from "components/shared/textArea/InputTextArea";
import FileUploadButton from "components/shared/fileUploadButton/FileUploadButton";
import { Controller, useForm } from "react-hook-form";
import TriggerButton from "components/shared/createTriggerButton/TriggerButton";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems, setUpdateDroppedItems } from "@redux/slices/formSlice";
import { handleFile, randomIntFromInterval } from "utils/utils";
import DeleteIcon from "@mui/icons-material/Delete";
import { setPublish } from "@redux/slices/globalSlice";
import { setDroppedItems as setTriggerList } from "@redux/slices/triggerSlice";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
const PhotoComponent = () => {
   const { publish } = useSelector((state) => state?.global);
  const dispatch = useDispatch();
  const { triggerDroppedList, trigger } = useSelector((state) => state.trigger);
  const { droppedItems, selectedData } = useSelector((state) => state.form);
  const { formId } = useParams()
  const navigate = useNavigate()
  const [value, setValue] = useState("");
  const [file, setFile] = useState("");
  const { register, handleSubmit, control, watch } = useForm({
    defaultValues: {
      showInstructions: false,
      allowNA: false,
      answers: [
        { label: "Yes", evaluation: "" },
        { label: "No", evaluation: "" },
      ],
      instructions: selectedData?.instructions || "",
      enableDependentQuestions: false,
    },
  });

  const handleChange = (field, value) => {
    const updatedData = { [field]: value };
    dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
    dispatch(setPublish(true));
  };

  const handleTextChange = (e, fieldName) => {
    setValue(e?.target?.value);
    handleChange(fieldName, e.target.value);
  };

  const handleFileChange = (file, setIsLoading) => {
    setFile(file);
    handleFile(file, droppedItems, selectedData, dispatch, setDroppedItems, setIsLoading);;
    dispatch(setPublish(true));
  };

  const onSubmit = (data) => {
    // console.log('Form Data:', data);
  };

  const handleClick = () => {
    // console.log('clicked....')
  };

  const handleImageDelete = (src, selectedItem) => {
    const updatedMedia = selectedItem?.data?.media.filter(
      (media) => media.path !== src
    );

    const updatedData = { media: updatedMedia };

    dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
    setFile("");
    dispatch(setPublish(true));
  };

  const handleOpenImage = (src) => {
    window.open(src, "__blank");
  };

  const currentItem = useMemo(
    () => droppedItems.find((item) => item.id === selectedData.id),
    [droppedItems, selectedData]
  );
  const handleTrigger = () => {
    const uniqueId = Date.now() + randomIntFromInterval(1000, 9999);
    dispatch(setTriggerList([
      ...triggerDroppedList, {
        ...currentItem,
        id: uniqueId
      }
    ]))
    navigate(`/create/triggers/${formId || ""}`)


  }


    const watchValues = watch();
    useEffect(() => {
        // if (!selectedData) return;
  
        const timeout = setTimeout(() => {
            dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData: watchValues }));
            // dispatch(setPublish(true));
        }, 500);
  
        return () => clearTimeout(timeout); // Cleanup on unmount
    }, [watchValues, selectedData]);
  return (
    <>
      <SectionField
        placeholder="Please enter your question here."
        message="Required"
      />
      <div
        // onSubmit={handleSubmit(submitForm)}
        className={styles?.instructionsForm}
      >
        <h4>Instructions</h4>
        <div className={styles?.formField}>
        <Controller
          name="instructions"
          control={control}
          render={({ field }) => (
                <InputTextArea
                  {...field}
                  control={control}
                  type="textarea"
                  name="Optional"
                  placeholder="Optional"
                  onChange={(e) => {
                      field.onChange(e);
                      dispatch(setPublish(true))
                  }}
                  className={styles.textArea}
                />
          )}
        />
        </div>
        <div className={styles?.formField}>
          {currentItem?.data?.media?.length ? (
            <div className={styles.imageContainer}>
              {currentItem?.data?.media?.map((src, index) => (
                <div
                  className={styles.imageWrapper}
                  onClick={() => handleOpenImage(src.path)}
                >
                  <img src={src.path} alt="" />
                  <div
                    className={styles.cancelIcon}
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleImageDelete(src.path, currentItem);
                    }}
                  >
                    <DeleteIcon sx={{ width: "20px", height: "20px" }} />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <FileUploadButton
              name="mediaFile"
              control={control}
              onFileChange={handleFileChange}
            />
          )}
        </div>
      </div>

      <form className={styles.formContainer} onSubmit={handleSubmit(onSubmit)}>
        {/* Checkbox: Show Instructions by Default */}
        <div>
          <label>
            <input
              type="checkbox"
              disabled={
                !watch("instructions") && !file && !currentItem?.data?.media?.length > 0
              }
              {...register("showInstructions")}
              onChange={(e) =>
                handleChange("showInstructions", e.target.checked)
              }
            />
            Show instructions by default
          </label>
        </div>

        {/* Button: Create Trigger */}
        <TriggerButton handleClick={() =>{
                    if(!publish){
                    handleTrigger()
                }else {
                    toast.error("There are unpublished changes");
                }
                }
                
                } />
      </form>
    </>
  );
};

export default PhotoComponent;
